exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner-container {\n  margin: 0px;\n  padding: 0px;\n  height: 230px;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n}\n@media (min-width: 4000px) {\n.section-container img {\n    height: 360px;\n}\n}", ""]);

// exports
